import { Address, Hex } from 'viem';

import { getActiveNetwork } from '@/lib/network/getActiveNetwork';
import { E_Network } from '@/ts/enums/E_Network';

// Staking contract constants
export const C_STAKING_CONTRACT_ADDRESSES: Record<E_Network, Hex> = {
  [E_Network.SEPOLIA]: '0xa31801b2d76F149458e2b14271B2C237CDe0F199',
  [E_Network.BASE]: '0x8785461DdfF11e87796Bb7c50CFB8E0C8DB54Ce8',
  [E_Network.BASE_SEPOLIA]: '0xfD1a28ebb89dDa3c3BEB3c6196e8Fba753e9E0b0'
};

export const C_TXONE_TOKEN_ADDRESSES: Record<E_Network, Hex> = {
  [E_Network.SEPOLIA]: '0xd487B8256853976f21A4700cE2ea5D1029deD78f',
  [E_Network.BASE]: '0x323C05bc83C549e2E3DEbA1BB6800a63e7220f24',
  [E_Network.BASE_SEPOLIA]: '0xAeacd4B823cf06a8d0CfF8dEbb57629e76fD4C4f'
};

export const C_STAKING_CONTRACT_ADDRESS = C_STAKING_CONTRACT_ADDRESSES[
  getActiveNetwork()
] as Address;

export const C_TXONE_TOKEN_ADDRESS = C_TXONE_TOKEN_ADDRESSES[
  getActiveNetwork()
] as Address;

export const C_TXONE_DECIMALS = 18 as const;
export const C_TXONE_DISPLAY_DECIMALS = 6 as const;
